<widget-pai-media
  [position]="'pos_' + (position + 1)"
  [page]="page"
></widget-pai-media>
